import { schemaToJsonLd } from '@/app/utilities/data/schemaGenerator';

interface SchemaProps {
    schema: any;
    id?: string;
}

/**
 * Component to render schema.org structured data as JSON-LD
 * @param schema - Schema object or array of schema objects to render
 */
export default function Schema({ schema, id }: SchemaProps) {
    if (!schema) return null;

    return (
        <script
            id={id}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: schemaToJsonLd(schema) }}
        />
    );
}
